import React from 'react';
import ChangeUnifiedTemplate from './ChangeUnifiedTemplate';
import { TicketData } from '../TicketDetail';

interface ChangeDetailTemplateProps {
  ticket: TicketData;
  isReadOnly: boolean;
  activeTab: 'details' | 'approvals' | 'notes' | 'activity' | 'assessment' | 'resolution' | 'attachments';
  setActiveTab: (tab: 'details' | 'approvals' | 'notes' | 'activity' | 'assessment' | 'resolution' | 'attachments') => void;
  onRefresh: () => void;
}

const ChangeDetailTemplate: React.FC<ChangeDetailTemplateProps> = (props) => {
  return <ChangeUnifiedTemplate {...props} />;
};

export default ChangeDetailTemplate;